export default __webpack_public_path__ + "static/media/wtfscreen.46dc1295.png";